import React from 'react';
import { IFlightDroneContext } from './types';

export const FlightDroneContext = React.createContext<IFlightDroneContext>({
  isLoading: false,
  refetch: () => {}
});

export const FlightDroneProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const refetch = React.useCallback(() => setIsLoading(true), []);

  const value = React.useMemo(
    () => ({ isLoading, refetch }),
    [isLoading, refetch]
  );

  return (
    <FlightDroneContext.Provider value={value}>
      {children}
    </FlightDroneContext.Provider>
  );
};